// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__adK7j","colMin":"styles_colMin__3o9TD"};